import { Fragment, useState, useEffect, useContext, type ChangeEvent } from "react";
import { Box, Checkbox, Divider, Button } from "@mui/material";
import { getCondition, updateCondition } from "../../api";
import SnackbarCustom, {
  type SnackbarData,
} from "../../components/SnackBarCustom";
import PopoverCustom from "../../components/PopoverCustom";
import { TokenContext } from "../../TokenContext";
import { DisasterConditionRole } from "../../role";
import type { MConditionItem, WarningCheckboxKey } from "../../types/condition";
import { buildConditionUpdatePayload as buildPayload } from "../../types/condition";

const columnsDisaster: ReadonlyArray<{
  warning: string;
  checkBox: WarningCheckboxKey;
}> = [
  { warning: "大雨特別警報", checkBox: "heavy_rain_warning" },
  { warning: "大雪特別警報", checkBox: "heavy_snow_warning" },
  { warning: "暴風特別警報", checkBox: "storm_warning" },
  { warning: "暴風雪特別警報", checkBox: "blizzard_warning" },
  { warning: "波浪特別警報", checkBox: "wave_warning" },
  { warning: "高潮特別警報", checkBox: "storm_surge_warning" },
  { warning: "土砂災害特別警報", checkBox: "landslide_warning" },
];

const DisasterJudge = () => {
  const tokenContext = useContext(TokenContext);
  const user = tokenContext?.user;
  const disasterConditionRole = DisasterConditionRole(
    user?.m_organization.m_role_id ?? 0
  );
  const [condition, setCondition] = useState<Partial<MConditionItem>>({
    heavy_rain_warning: false,
    heavy_snow_warning: false,
    storm_warning: false,
    blizzard_warning: false,
    wave_warning: false,
    storm_surge_warning: false,
    landslide_warning: false,
  });

  const getDisasterCondition = async () => {
    try {
      const response = await getCondition();
      if (response.status === "ok") {
        const data = response.m_condition;
        console.log("災害判定条件(警報)取得", data);
        setCondition(data);
      }
    } catch (error) {
      console.error("API呼び出しエラー", error);
    }
  };

  useEffect(() => {
    getDisasterCondition();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleChangeCheckBox = (
    e: ChangeEvent<HTMLInputElement>,
    column: WarningCheckboxKey
  ) => {
    const newValue = e.target.checked;
    setCondition((prevCheck) => ({
      ...prevCheck,
      [column]: newValue,
    }));
  };

  const [confirmPopoverOpen, setPopoverSplitOpen] = useState(false);
  const registerButtonClick = () => {
    setPopoverSplitOpen(true);
  };
  const confirmPopupClose = () => {
    setPopoverSplitOpen(false);
  };

  const putConditionData = async (isSuccess: boolean) => {
    if (!isSuccess) {
      console.log("何も行いません");
      return;
    }

    const params = buildPayload(condition);
    console.log("入力データ", params);
    try {
      const status = await updateCondition(params, { id: 1 });
      console.log("レスポンスデータ:", status);
      setSnackBarstatus(status);
      setSnackbarOpen(true);
    } catch (error) {
      console.error("エラーが発生しました:", error);
    }
  };

  const [snackBarstatus, setSnackBarstatus] = useState<SnackbarData>();
  const [snackbarOpen, setSnackbarOpen] = useState(false);

  return (
    <>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: "8px",
          width: "100%",
          maxWidth: "480px",
        }}
      >
        {columnsDisaster.map((column) => (
          <Fragment key={`disaster${column.warning}`}>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                minWidth: "min-content",
                fontSize: 16,
                fontWeight: "bold",
                color: "#000",
                whiteSpace: "nowrap",
              }}
            >
              <Box
                sx={{
                  minWidth: "160px",
                  padding: "0px 0",
                  "@media screen and (max-width:900px)": {
                    padding: "0",
                  },
                }}
              >
                {column.warning}
              </Box>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "flex-start",
                  width: "100%",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "flex-end",
                  }}
                >
                  <Checkbox
                    name={`checkbox_${column.checkBox}`}
                    size="small"
                    checked={Boolean(condition[column.checkBox])}
                    onChange={(e) => handleChangeCheckBox(e, column.checkBox)}
                    disabled={!disasterConditionRole.update}
                  />
                </Box>
              </Box>
            </Box>
            <Divider />
          </Fragment>
        ))}
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            gap: "16px",
            paddingTop: "8px",
            "@media screen and (max-width:600px)": {
              flexDirection: "column",
              alignItems: "center",
            },
          }}
        >
          <Button
            name="registrationButtonDisasterJudge"
            variant="contained"
            onClick={() => registerButtonClick()}
            sx={{ width: "208px" }}
            disabled={!disasterConditionRole.update}
          >
            登録
          </Button>
        </Box>
      </Box>
      <SnackbarCustom
        data={snackBarstatus}
        openStatus={snackbarOpen}
        onClose={() => setSnackbarOpen(false)}
      />
      <PopoverCustom
        locatorName="popoverDisasterJudge"
        open={confirmPopoverOpen}
        onClose={confirmPopupClose}
        yesNo={putConditionData}
        title={"登録確認"}
        contents={"災害判定条件（警報）を登録してもよろしいですか？"}
      />
    </>
  );
};

export default DisasterJudge;
